import { render } from "./DepositDialog.vue?vue&type=template&id=317d9be8&scoped=true&ts=true"
import script from "./DepositDialog.vue?vue&type=script&lang=ts"
export * from "./DepositDialog.vue?vue&type=script&lang=ts"

import "./DepositDialog.vue?vue&type=style&index=0&id=317d9be8&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317d9be8"]])

export default __exports__